import { z } from 'zod';

export const getBasicQuestInfoOutputSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  subdomain: z.string(),
  communityName: z.string().nullable(),
  communityImage: z.string().nullable(),
  communityDescription: z.string().nullable(),
});

export const getBasicQuestInfoPathSchema = z.object({
  questId: z.string().uuid(),
});

export type GetBasicQuestInfoOutput = z.infer<typeof getBasicQuestInfoOutputSchema>;
